const mutations = {
  setBenefitCategories(state, categories) {
    state.benefitCategories = categories;
  },
  setBenefitCategory(state, category) {
    state.benefitCategory = category
  },
};

export default mutations;